// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import PaginationPresentationPropsDefault from "@insite/mobius/Pagination/presentationProps";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import buttonSizeVariants from "@pacific/MobiusOverrides/Button/buttonSizeVariants";
import Next from "@pacific/XDL/Icons/Next";
import Previous from "@pacific/XDL/Icons/Previous";
import { xBaseTheme } from "@pacific/XDL/types";
import { color } from "@pacific/XDL/Utilities";
import { mergeWithCss } from "@pacific/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...PaginationPresentationPropsDefault,
        selectProps: {
            labelProps: {
                size: 15,
                weight: "normal",
            },
        },
        navIconsSrc: {
            firstPage: "ChevronsLeft",
            previousPage: Previous,
            nextPage: Next,
            lastPage: "ChevronsRight",
        },

        buttonProps: {
            mergeCss: true,
            sizeVariant: "small",
            typographyProps: {
                size: 12,
                lineHeight: "13px",
            },
            css: css`
                min-height: ${buttonSizeVariants["small"].height}px;
                border: none;
                &:hover:not(:disabled) {
                    background: ${color("common.ui8")};
                    border: none;
                    color: ${color("common.ui1")};
                }
            `,
        },
        cssOverrides: {
            ...mergeWithCss(PaginationPresentationPropsDefault?.cssOverrides, {
                ellipsis: css`
                    margin: 0 10px;
                `,
                linkList: css`
                    & > ul {
                        display: flex;
                        align-items: center;
                    }
                `,
            } as PaginationPresentationProps["cssOverrides"]),
        },
    },
} as xBaseTheme["pagination"];
